const centerByCountry = (country: string) => {
    switch (country) {
    case 'México':
    case 'Mexico':
        return {
            lng: -99.133209,
            lat: 19.432607,
        };
    case 'República Dominicana':
        return {
            lng: -70.669291,
            lat: 18.466338,
        };
    case 'Colombia':
        return {
            lng: -74.072092,
            lat: 4.60971,
        };
    case 'Argentina':
        return {
            lng: -58.3816,
            lat: -34.6037,
        };
    case 'Chile':
        return {
            lng: -70.6693,
            lat: -33.4489,
        };
    case 'Uruguay':
        return {
            lng: -56.1645,
            lat: -34.9011,
        };
    default:
        return {
            lng: -78.4678,
            lat: -0.1807,
        };
    }
};

export {
    centerByCountry,
};
